"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.valueMessages = exports.Value = void 0;
const schema_1 = require("../../../schema");
var Value;
(function (Value) {
    Value["DCM"] = "dcm";
    Value["ISCHAEMIC_HEART_DISEASE"] = "ischaemic_heart_disease";
    Value["VALVULAR_HEART_DISEASE"] = "valvular_heart_disease";
    Value["CONGENITAL_HEART_DISEASE"] = "congenital_heart_disease";
    Value["RESTRICTIV_CARDIMOMYOPATHY"] = "restrictiv_cardimomyopathy";
    Value["HYPERTROFIC_CARDIOMYOPATHY"] = "hypertrofic_cardiomyopathy";
    Value["CARDIAC_TUMOR"] = "cardiac_tumor";
    Value["POSTTRANSPLANT_ETIOLOGY"] = "posttransplant_etiology";
    Value["EISENMENGER_SY"] = "eisenmenger_sy";
    Value["PRIMARY_PULMONARY_HYPERTENSION"] = "primary_pulmonary_hypertension";
    Value["MYOCARDITIS"] = "myocarditis";
    Value["AMYLOIDOSIS"] = "amyloidosis";
    Value["OTHER_ETIOLOGY"] = "other_etiology";
})(Value || (exports.Value = Value = {}));
exports.valueMessages = {
    [Value.DCM]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.DCM",
        defaultMessage: "Dilatatív kardiomiopátia"
    },
    [Value.ISCHAEMIC_HEART_DISEASE]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.ISCHAEMIC_HEART_DISEASE",
        defaultMessage: "Iszkémiás szívbetegség"
    },
    [Value.VALVULAR_HEART_DISEASE]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.VALVULAR_HEART_DISEASE",
        defaultMessage: "Billentyű betegség talaján"
    },
    [Value.CONGENITAL_HEART_DISEASE]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.CONGENITAL_HEART_DISEASE",
        defaultMessage: "Congenitális eredetű"
    },
    [Value.RESTRICTIV_CARDIMOMYOPATHY]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.RESTRICTIV_CARDIMOMYOPATHY",
        defaultMessage: "Restriktív kardiomiopátia"
    },
    [Value.HYPERTROFIC_CARDIOMYOPATHY]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.HYPERTROFIC_CARDIOMYOPATHY",
        defaultMessage: "Hypertrófiás kardiomiopátia"
    },
    [Value.CARDIAC_TUMOR]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.CARDIAC_TUMOR",
        defaultMessage: "Kardiális tumor"
    },
    [Value.POSTTRANSPLANT_ETIOLOGY]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.POSTTRANSPLANT_ETIOLOGY",
        defaultMessage: "Posttranszplantációs etiológia"
    },
    [Value.EISENMENGER_SY]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.EISENMENGER_SY",
        defaultMessage: "Eisenmenger szindróma"
    },
    [Value.PRIMARY_PULMONARY_HYPERTENSION]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.PRIMARY_PULMONARY_HYPERTENSION",
        defaultMessage: "Primer pulmonális hypertónia"
    },
    [Value.MYOCARDITIS]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.MYOCARDITIS",
        defaultMessage: "Myocarditis"
    },
    [Value.AMYLOIDOSIS]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.AMYLOIDOSIS",
        defaultMessage: "Amiloidózis"
    },
    [Value.OTHER_ETIOLOGY]: {
        id: "htx.medicalHistory.heartFailureEtiology.value.OTHER_ETIOLOGY",
        defaultMessage: "Egyéb etiológia"
    }
};
const value = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Value.DCM),
    schema_1.Schema.singleChoiceItem(Value.ISCHAEMIC_HEART_DISEASE),
    schema_1.Schema.singleChoiceItem(Value.VALVULAR_HEART_DISEASE),
    schema_1.Schema.singleChoiceItem(Value.CONGENITAL_HEART_DISEASE),
    schema_1.Schema.singleChoiceItem(Value.RESTRICTIV_CARDIMOMYOPATHY),
    schema_1.Schema.singleChoiceItem(Value.HYPERTROFIC_CARDIOMYOPATHY),
    schema_1.Schema.singleChoiceItem(Value.CARDIAC_TUMOR),
    schema_1.Schema.singleChoiceItem(Value.POSTTRANSPLANT_ETIOLOGY),
    schema_1.Schema.singleChoiceItem(Value.EISENMENGER_SY),
    schema_1.Schema.singleChoiceItem(Value.PRIMARY_PULMONARY_HYPERTENSION),
    schema_1.Schema.singleChoiceItem(Value.MYOCARDITIS),
    schema_1.Schema.singleChoiceItem(Value.AMYLOIDOSIS),
    schema_1.Schema.singleChoiceItem(Value.OTHER_ETIOLOGY)
]).interpretation({ vocab: "htx", code: "heart_failure_etiology" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
